import { Box, CircularProgress, Divider, styled } from "@mui/material";
import { useContext, useState } from "react";
import { MyTrainingsViewContext } from "context/myTrainings/MyTrainingsViewContext";
import { MyTrainingsViewContextProvider } from "context/myTrainings/MyTrainingsViewContextProvider";
import { MobileHomeHeaderComponent } from "components/Mobile/HomeHeaderComponent";
import { MobileHomeStatisticsComponent } from "components/Mobile/HomeStatisticsComponent";
import { MobileHomeLessonComponent } from "components/Mobile/HomeLessonComponent";
import { MobileMenuComponent } from "components/Mobile/MenuComponent";
import { MobileMenuButton } from "./MobileMenuButton";

const LoadingBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
});

const PageBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(5),
  gap: theme.spacing(2),
  overflowY: "auto",
  minHeight: "100vh",
  backgroundColor: theme.palette.common.white,
}));

const MobileHomePageContent = () => {
  const { user, trainingStatistics } = useContext(MyTrainingsViewContext);
  const [menuOpen, setMenuOpen] = useState(false);

  if (!user) {
    return (
      <LoadingBox>
        <CircularProgress />
      </LoadingBox>
    );
  }

  return (
    <PageBox>
      <MobileMenuButton onClick={() => setMenuOpen(true)} />
      <MobileMenuComponent open={menuOpen} onClose={() => setMenuOpen(false)} />
      <MobileHomeHeaderComponent />
      <MobileHomeStatisticsComponent />
      <Divider />
      {trainingStatistics && (
        <>
          <MobileHomeLessonComponent />
        </>
      )}
    </PageBox>
  );
};

export const MobileHomePage = () => (
  <MyTrainingsViewContextProvider>
    <MobileHomePageContent />
  </MyTrainingsViewContextProvider>
);
